import React from "react";
import styled from "styled-components";
import device from "../helpers/device";
import { timeImg } from "../assetManager";

export default class ScheduleRow extends React.Component {
  render() {
    const { time, title, last } = this.props;
    return (
      <Schedule className={`open ${last ? "last" : ""}`}>
        <div className="inner">
          <div className="head">
            <img src={timeImg[`time_${time}`]} width="125" alt="" />
          </div>
          <div className="body">
            <Session className="last">
              <div className="top">
                <div className="wrap">
                  <div className="title">{title}</div>
                </div>
              </div>
            </Session>
          </div>
        </div>
      </Schedule>
    );
  }
}

const Schedule = styled.div`
  border-top: 1px solid #d9d4d2;
  width: 100%;
  &.last {
    border-bottom: 1px solid #d9d4d2;
    .body {
      display: block;
    }
    > .inner {
      @media ${device.mobileL} {
        padding-top: 40px;
      }
    }
  }
  @media ${device.mobileL} {
    margin-top: 20px;
  }
  > .inner {
    padding: 0px 20px 0 20px;
    display: flex;
    flex-direction: column;
    @media ${device.mobileL} {
      flex-direction: row;
      padding: 60px 80px 0 60px;
    }
  }
  .head {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      transform: rotate(-180deg);
    }
    img {
      vertical-align: middle;
      @media ${device.mobileL} {
        width: 160px;
      }
    }
    @media ${device.mobileL} {
      padding: 0 30px 0 0;
      align-items: start;
      span {
        display: none;
      }
    }
  }
`;

const Session = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  cursor: pointer;
  height: calc(100% - 20px);
  a,
  .wrap {
    border-left: 4px solid #3f271e;
    padding-left: 10px;
    color: #3f271e;
    text-decoration: none;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .wrap {
    cursor: default;
  }
  @media ${device.mobileL} {
    min-height: 200px;
    margin-left: 30px;
    margin-bottom: 30px;
    a {
      padding-top: 10px;
      padding-left: 20px;
      transition: opacity 0.1s linear;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  &.last {
    @media ${device.mobileL} {
      min-height: auto;
      margin-bottom: 40px;
    }
  }
  .bottom {
    padding-top: 15px;
  }
  .title {
    font-weight: bold;
  }
`;
